import React, { useCallback } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { selectCrossClientResultsExecution, selectCrossClientTabCounts } from '../../../store/crossClient/crossClientResults'
import { selectCrossClientActionedClientIds } from '../../../store/crossClient/crossClientActions'
import { CrossClientQueryResultStatuses } from '../../../models/CrossClient'
import { useLazyGetAllCrossClientQueryExecutionResultsQuery } from '../../../store/crossClient/crossClient'
import { CrossClientChooseActionDropdown } from './CrossClientChooseActionDropdown'

export const CrossClientIncompleteActions: React.FC = () => {
  const accountId = useAppSelector(selectAccountId)
  const execution = useAppSelector(selectCrossClientResultsExecution)
  const counts = useAppSelector(selectCrossClientTabCounts)
  const actionedClientIds = useAppSelector(selectCrossClientActionedClientIds)
  const [triggerGetAllResults] = useLazyGetAllCrossClientQueryExecutionResultsQuery()

  const resolveTargets = useCallback(async () => {
    if (!execution?.id) {
      return []
    }
    const response = await triggerGetAllResults({
      accountId,
      executionId: execution.id,
      status: CrossClientQueryResultStatuses.NO_DATA,
    }).unwrap()
    return response.data.filter((result) => !actionedClientIds.has(result.clientId))
  }, [accountId, execution, actionedClientIds, triggerGetAllResults])

  return <CrossClientChooseActionDropdown count={counts.incomplete} resolveTargets={resolveTargets} />
}
